import React from 'react';
import './Finace.css'

const Finance = () => {
    return (
        <div>
            This is Finance, comming soon 
        </div>
    );
};

export default Finance;